import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoginService } from './login.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { AuthObservabilityService } from '../shared/monitoring/auth-observability.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly loginService: LoginService,
    private readonly authObservability: AuthObservabilityService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isOwnBackendRequest(request)) {
      return next.handle(request);
    }

    return this.loginService.token.pipe(
      map((tokenValue) => {
        if (tokenValue) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${tokenValue}`,
            },
          });
        }
        return request;
      }),
      mergeMap((modifiedRequest) => next.handle(modifiedRequest)),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          this.authObservability.trackAccessDenied();
        }
        return throwError(error);
      }),
    );
  }

  private isOwnBackendRequest(request: HttpRequest<unknown>): boolean {
    return request.url.startsWith(environment.backend.url) || request.url.startsWith(environment.backend.widget);
  }
}
